/**
 * Country flags where the system has none: Chrome and Edge on Windows show two letters ("GE")
 * instead of a flag emoji. There, a small self-hosted font with just the flags loads (Twemoji
 * graphics, CC BY 4.0, credited in the Terms); every other browser keeps its own flags and never
 * fetches it. global.css puts the font first in --font and --mono, and its unicode-range covers
 * only flag characters (docs/architecture.md §5).
 */
import { polyfillCountryFlagEmojis } from 'country-flag-emoji-polyfill';
import fontUrl from 'country-flag-emoji-polyfill/dist/TwemojiCountryFlags.woff2?url';

export function installFlagFont(): void {
  polyfillCountryFlagEmojis('Twemoji Country Flags', fontUrl);
}
